import React, { Component } from 'react';
import { message } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import UpdateScore from './UpdateScore';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import UserSider from '../UserSider';
import Filter from './Filter';
import List from './List';
import '../css/style.less';

class CrcTeamContributeScore extends Component {
    state = {
        data: [],
        sortParams: {},
        searchParams: {},
        pagination: {
            pageSize: 10,
            current: 1,
        },
        loading: false,
        canSynchronize: false,
        config: {},
    }

    search = ({
            pagination = {
                pageSize: 10,
                current: 1,
            },
            ...rest
        }) => {
        this.setState({
            pagination,
            ...rest,
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, searchParams, pagination } = this.state;
        const params = {
            ...sortParams,
            ...searchParams,
        }
        ExportUtil.export(params, pagination, API_URL.user.exportCRCScoreGradeList);
    }

    // 同步人员
    synchronizeUser = () => {
        this.setState({ loading: true });
        const options = {
            url: API_URL.user.updateCrcScoreGradeMember,
            data: {},
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    loadData = () => {
        const { sortParams, searchParams, pagination, pagination: { current, pageSize } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.queryCrcScoreGradeList,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { data = {}, datas = [], totalCount = 0 } = res;
                pagination.total = totalCount;
                const { canSynchronize } = data;

                this.setState({
                    pagination,
                    data: datas,
                    config: data,
                    loading: false,
                    canSynchronize: canSynchronize == 'true',
                });
            }
        };
        $.sendRequest(options);
    }

    updateScore = (record) => {
        this.updateScoreRef.show(record);
    }

    render() {
        const { data, config, loading, sortParams, pagination, canSynchronize } = this.state;
        return (
            <div className="content pmInfo">
                <UserSider selectKey='crcTeamContributeScore' openKeys={['sub3']}/>
                <div className="main">
                    <div className="main-content">
                        <Filter
                            search={this.search}
                            export={this.export}
                            canSynchronize={canSynchronize}
                            synchronizeUser={this.synchronizeUser}
                        />
                        <List
                            data={data}
                            config={config}
                            loading={loading}
                            search={this.search}
                            sortParams={sortParams}
                            pagination={pagination}
                            updateScore={this.updateScore}
                        />
                        <UpdateScore ref={el => this.updateScoreRef = el} config={config} loadData={this.loadData} />
                    </div>
                </div>
            </div>
        );
    }
}

export default CrcTeamContributeScore;


// WEBPACK FOOTER //
// ./src/components/user/crcTeamContributeScore/index.js